/**
 * Centralized constants for Emission Point permissions.
 * Follows the pattern: backoffice:document-mission-point:{action}
 */
export const EMISSION_POINT_PERMISSIONS = {
  VIEW: 'backoffice:document-mission-point:view',
  CREATE: 'backoffice:document-mission-point:create',
  UPDATE: 'backoffice:document-mission-point:update',
  DELETE: 'backoffice:document-mission-point:delete',
  VIEW_AUDIT_LOG: 'backoffice:document-mission-point-audit-log:view',
  EXPORT: 'backoffice:document-mission-point:export',
  RANGE_LIST: 'backoffice:document-mission-point-range:list',
} as const;

export type EmissionPointPermission = typeof EMISSION_POINT_PERMISSIONS[keyof typeof EMISSION_POINT_PERMISSIONS];
